<template>
  <div class="rechargeWay">
    <div class="items" v-show=" actCurrency == '' || !!$route.query.tradeSerialNo ">
      <div class="item" v-for="(item,i) in currencyList" @click="currencyAct = item" :class="{ act : currencyAct.currency_short == item.currency_short }">
        {{item.currency_short}}
        <i class="iconfont icon-shiliangzhinengduixiang"></i>
      </div>
    </div>

    <div>
      <div class="ways" v-show="ableWayList.length > 0">
        <div class="way" v-for="(item,i) in ableWayList" @click="wayAct = item.way" :class="{ act : wayAct == item.way }" v-show="1"  ><!-- v-show=".search(//)" -->
          <img :src="item.img" alt="">
          <div>
            <p v-text="item.word"></p>
            <span v-if="item.word != ''">{{pc_lang.Top_up}}</span>
          </div>
          <i class="iconfont icon-shiliangzhinengduixiang"></i>
        </div>
      </div>
    </div>

    <div class="wayInfo" v-if="currencyAct != ''">
        <AliPay v-if="wayAct == 'alipay'" :currencyShort="currencyAct.currency_short" :currencyAct="currencyAct"></AliPay>
        <WeixinPay v-if="wayAct == 'weixin'" :currencyShort="currencyAct.currency_short" :currencyAct="currencyAct"></WeixinPay>
        <Billplz v-if="wayAct == 'billplz'" :currencyShort="currencyAct.currency_short"></Billplz>
        <FPX v-if="wayAct == 'fpx'" :currencyShort="currencyAct.currency_short"></FPX>
        <CreditCard v-if="wayAct == 'credit'" :currencyShort="currencyAct.currency_short"></CreditCard>
        <Ebanking v-if="wayAct == 'ebanking'" :currencyShort="currencyAct.currency_short"></Ebanking>
        <ATM v-if="wayAct == 'atm'" :currencyShort="currencyAct.currency_short"></ATM>
        <Cash v-if="wayAct == 'cash'" :currencyShort="currencyAct.currency_short"></Cash>
     </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as way from './way'

export default {
  name: 'rechargeWay',
  props: ['actCurrency'],
  data(){
    return {
      currencyAct: '',
      wayAct: '',
      wayList: [
        {
          img: require('@/assets/image/alipay.png'),
          way: 'alipay',
          word: ''
        },
        {
          img: require('@/assets/image/weixinpay.png'),
          way: 'weixin',
          word: ''
        },
        {
          img: require('@/assets/image/billplz.png'),
          way: 'billplz',
          word: 'Billplz'
        },
        {
          img: require('@/assets/image/FPX.png'),
          way: 'fpx',
          word: 'FPX'
        },
        {
          img: require('@/assets/image/credit_card.png'),
          way: 'credit',
          word: '信用卡'
        },
        {
          img: require('@/assets/image/ebanking.png'),
          way: 'ebanking',
          word: 'E-banking'
        },
        {
          img: require('@/assets/image/ATM.png'),
          way: 'atm',
          word: 'ATM'
        },
        {
          img: require('@/assets/image/cash.png'),
          way: 'cash',
          word: 'Cash'
        }
      ],
      ableWayList: []
    }
  },
  computed: {
    ...mapGetters(['currencyList']),
  },
  components: {
    ...way
  },
  async mounted() {

  },
  created(){
    this.currencyAct = this.actCurrency
    this.initUI()
  },
  methods: {
    initUI() {
      if (this.currencyList.length && !!!this.currencyAct) {
        this.currencyAct = this.currencyList[0]
      }
    }
  },
  watch: {
    currencyAct: {
      handler(val, oldVal) {
        this.wayAct = ''
        if (!!!val || !!!val.way ) {
          this.ableWayList = []
        } else {
          if (!!this.$route.query.tradeSerialNo) {
            this.ableWayList = this.wayList.filter(obj=> {
              return val.pay_way.indexOf(obj.way) > -1
            })
          } else {
            this.ableWayList = this.wayList.filter(obj=> {
              return val.way.indexOf(obj.way) > -1
            })
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.act{
  border-style: solid;
  color: $blue;
  border-color: $blue;
  &:after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    right: 0;
    top: 0;
    border: 11px solid;
    border-color: $blue $blue rgba(0,0,0,0) rgba(0,0,0,0);
  }
  &:before{
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    left: calc(50% - 5px);
    top: calc(100% + 7px);
    background: #fff;
    transform: rotate(-45deg);
    border: 2px solid;
    border-color: #dedede #dedede rgba(0,0,0,0) rgba(0,0,0,0);
  }
}

.icon{
  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  z-index: 2;
  font-size: 12px;
  transform: scale(.9);
}

.items{
  display: flex;
  align-items: center;
  padding: 20px 0 10px;
  border-bottom: 2px solid #dedede;
  user-select: none;
  .item{
    position: relative;
    padding: 6px 24px;
    margin-right: 10px;
    font-size: 18px;
    color: #333;
    border: 1px dashed #dedede;
    border-radius: 5px;
    cursor: pointer;
    &.act{
      @extend .act;
    }
    i{
      @extend .icon;
    }
  }
}

.ways{
  display: flex;
  align-items:center;
  padding: 20px 0 10px;
  border-bottom: 2px solid #dedede;
  user-select: none;
  .way{
    position: relative;
    display: flex;
    align-items:center;
    justify-content: center;
    padding: 12px 10px;
    min-width: 180px;
    color: #333;
    border: 1px dashed #dedede;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
    &.act{
      @extend .act;
    }
    i{
      @extend .icon;
    }
    >div{
      margin-left: 8px;
      p{
        font-size: 20px;
      }
    }
  }
}

.wayInfo{
  margin-top: 20px;
}

</style>